module.exports = __webpack_public_path__ + "img/lk-menu-payment-method.40362855.svg";